import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from "classnames";
import { Container } from "../../../../eva-components/Container";
import { HealthBanner } from "./HealthBanner";
import styles from "./HealthBanner.module.scss";
export const FooterHealthBanner = (healthBannerProps) => {
    if (!healthBannerProps.content) {
        return null;
    }
    return (_jsx(_Fragment, { children: healthBannerProps.variant === "default" ? (_jsx(Container, { className: classNames({
                [styles.bannerDefaultWrapper]: healthBannerProps.variant === "default",
            }), children: _jsx(HealthBanner, { ...healthBannerProps }) })) : (_jsx(HealthBanner, { ...healthBannerProps })) }));
};
//# sourceMappingURL=FooterHealthBanner.js.map